<template>
  <info-panel
    :preview-id="id"
    :collapsible="collapsible"
    :info-panel-header="$t('addTags')"
    :initially-collapsed="initiallyCollapsed"
    v-if="showAsInfoPanel"
  >
    <div slot="info">
      <tag
          :name="team.displayName"
          :is-removable="!readOnly"
          icon-left="users"
          @removeTag="removeTag"
          v-for="(team, index) in tags"
          :key="index"
          :tag="team"
          :organization-id="team.organizationId"
      />
      <div v-if="!tags || !tags.length">
        <p class="lighter">{{ $t('noTagsAvailable') }}</p>
      </div>
      <universal-selector
          v-if="!readOnly"
          class="mt-2"
          @addItem="addTag"
          :exclude-from-item-list="tags"
          list-name="tagList"
          store-name="Tag"
          filter-attribute="name"
          :limit-by-organization-id="limitByOrganizationId"
          tag-icon="users"
          :show-organization="true"
      />
      <div class="w-100" />
    </div>
  </info-panel>
  <div v-else>
    <tag
        :name="team.displayName"
        :is-removable="true"
        icon-left="users"
        @removeTag="removeTag"
        v-for="(team, index) in tags"
        :key="index"
        :tag="team"
        :organization-id="team.organizationId"
    />
    <universal-selector
        class="mt-2"
        @addItem="addTag"
        :exclude-from-item-list="tags"
        list-name="tagList"
        store-name="Tag"
        filter-attribute="name"
        :limit-by-organization-id="limitByOrganizationId"
        tag-icon="users"
        :show-organization="true"
    />
  </div>
</template>

<script>
import UniversalSelector from "@/components/organizations/UniversalSelector";
import Tag from "@/components/Tag";
import InfoPanel from "@/components/InfoPanel";
export default {
  name: "TagAttacher",
  components: {
    UniversalSelector,
    Tag,
    InfoPanel,
  },
  props: {
    tags: {type: Array, default: () => {return []}},
    id: {type: String, required: true},
    /**
     * @organizationId limit entries for a spezific organization
     * */
    limitByOrganizationId: {type: String, default: ''},
    storeName: {type: String, required: true},
    initiallyCollapsed: {type: Boolean, required: false, default: false},
    showAsInfoPanel: {type: Boolean, default: true},
    readOnly: {type: Boolean, default: false},
    collapsible: {type: Boolean, default: true}
  },
  data() {
    return {
    }
  },
  methods: {
    addTag(tag) {
      this.$store.dispatch(`clientAdd${this.storeName}Tags`, {
        id: this.id,
        args: [tag.id],
      }).then(() => {
        this.$emit('added', tag.id);
      })
    },
    removeTag(tag) {
      this.$store.dispatch(`clientRemove${this.storeName}Tags`, {
        id: this.id,
         args: [tag.id],
      }).then(() => {
        this.$emit('removed', tag.id);
      })
    },
  }
}
</script>